import Dashboard from 'containers/Dashboard'

import Clients from 'scenes/Clients'
import NewClient from 'scenes/NewClient'
import ClientDetail from 'scenes/ClientDetail'

import VehicleRoutes from './vehicles.js'


const routes = {
  path: '/clientes',
  breadcrumb: 'Clientes',
  component: Clients,
  container: Dashboard,

  routes: {
    new: {
      path: '/nuevo',
      breadcrumb: 'Crear cliente',
      component: NewClient
    },
    detail: {
      path: '/:id',
      breadcrumb: ':client_name',
      component: ClientDetail,
      routes: VehicleRoutes
    },
    detailhistory: {
      path: '/:id',
      breadcrumb: ':client_name',
      component: ClientDetail,
      routes: VehicleRoutes
    },
  }
}

export default routes



// WEBPACK FOOTER //
// ./src/routes/clients.js